import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import * as Papa from 'papaparse';

@Injectable({
  providedIn: 'root'
})
export class FileUploadService {

  private SERVER_PATH = environment.functionsPath;

  constructor(private http: HttpClient) { }

  parseCSV(csvContent: string): { columnHeaders: string[], data: any[] } {

    const result = Papa.parse(csvContent, {
      header: true,
      skipEmptyLines: true,
      dynamicTyping: true
    });

    return {
      columnHeaders: result.meta.fields || [],
      data: result.data
    };
  }


  // private async getIdToken() {
  //   const user = await this.afAuth.currentUser;
  //   if (user) {
  //     return user.getIdToken();
  //   }
  //   return null;
  // }
}
